import { render, staticRenderFns } from "./moneyClaim_list.vue?vue&type=template&id=efb30908"
import script from "./moneyClaim_list.vue?vue&type=script&lang=js"
export * from "./moneyClaim_list.vue?vue&type=script&lang=js"
import style0 from "./moneyClaim_list.vue?vue&type=style&index=0&id=efb30908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports